import { createAction, props } from "@ngrx/store";
import { ITag } from "../models/tags.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// fetch all tags
export const FetchAllTags = createAction(
  '[ Tags ] - FetchAllTags',
  props<{ includes?: Array<string> }>()
);
export const FetchAllTagsSuccess = createAction(
  '[ Tags ] - FetchAllTags Success ',
  props<{ tags: ITag[] }>()
);
export const FetchAllTagsError = createAction(
  '[ Tags ] - FetchAllTag Error',
);

// fetch tags
export const FetchTags = createAction(
  '[ Tags ] - FetchTags',
  props<{ page: IPageCount, key?: string | undefined }>()
);
export const FetchTagsSuccess = createAction(
  '[ Tags ] - FetchTags Success ',
  props<{ tags: APIResponse<ITag>}>()
);
export const FetchTagsError = createAction(
  '[ Tags ] - FetchTag Error',
);

// add tag
export const AddTag = createAction(
  '[ Tag ] - AddTag',
  props<{ tag: ITag }>()
);
export const AddTagSuccess = createAction(
  '[ Tag ] - AddTag Success ',
  props<{ tag: ITag }>()
);
export const AddTagError = createAction(
  '[ Tag ] - AddTag Error',
);

// Update tag
export const UpdateTag = createAction(
  '[ Tag ] - UpdateTag',
  props<{ id: number, tag: ITag }>()
);
export const UpdateTagSuccess = createAction(
  '[ Tag ] - UpdateTag Success ',
  props<{ tag: ITag }>()
);
export const UpdateTagError = createAction(
  '[ Tag ] - UpdateTag Error',
);


// Delete tag
export const DeleteTag = createAction(
  '[ Tag ] - DeleteTag',
  props<{ id: number }>()
);
export const DeleteTagSuccess = createAction(
  '[ Tag ] - DeleteTag Success ',
);
export const DeleteTagError = createAction(
  '[ Tag ] - DeleteTag Error',
);

// looder actions
export const SetTagsLoader = createAction(
  '[ Tags ] - SetLoading',
  props<{ isLoading: boolean }>()
);

// search
export const SetTagSearch = createAction( 
  '[ Tags ] - SetSearch',
  props<{ keyword: string }>()
)